import { render, staticRenderFns } from "./ChartRadar.vue?vue&type=template&id=457792b3&scoped=true"
import script from "./ChartRadar.vue?vue&type=script&lang=js"
export * from "./ChartRadar.vue?vue&type=script&lang=js"
import style0 from "./ChartRadar.vue?vue&type=style&index=0&id=457792b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457792b3",
  null
  
)

export default component.exports